<template>
  <a-select
      show-search
      placeholder="请选择供应商"
      option-filter-prop="children"
      style="width: 155px"
      size="large"
      :filter-option="false"
      :getPopupContainer="trigger => trigger.parentNode"
      @popupScroll="goodsScroll"
      @search="fetchSupplier"
      @change="chooseOption"
      :value="currentValue.label?currentValue:undefined"
      label-in-value>
    <a-select-option v-for="(item,index) in supplierList" :key="index" :value="item.id">
      {{item.name}}
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "supplierSelector",
  props:{
   currentValue:{
      type:Object,
    }
  },
  data(){
    return{
      supplierList:[],
      queryParam:{
        current:1,
        size:20,
        name:'',
      },
      selectOption:'',
      text:'',
    }
  },
  created() {
    this.getSupplierDropDownList(this.queryParam);
  },
  methods:{
    chooseOption(value){
      this.$emit('supplierSelectChange',value);
    },
    fetchSupplier(value){
      const params = {
        current:1,
        size:this.queryParam.size,
        name:value,
      }
      this.getSupplierDropDownList(params);
    },
    goodsScroll(e){
      const { target } = e;
      if(target.scrollTop+target.offsetHeight===target.scrollHeight){
        const nextIndex = this.queryParam.current+1;
        this.setIndex(nextIndex);
        this.getSupplierDropDownList(this.queryParam)
      }
    },
    setIndex(index){
      this.queryParam.current = index;
    },
    getSupplierDropDownList(params){
      const staffRoles = this.$store.getters.userInfo.roleIds;
      const userType = this.$store.getters.userInfo.staffType;
      //公司负责人
      if(0===userType&&staffRoles.indexOf("2")!==-1){
        this.$api.company.companyBindSupplierDropDownList(params).then(res => {
          if (res.code === 200 && res.success) {
            this.supplierList = res.data.records;
          }
        });
      }else if(0===userType){
        const restaurantId = this.$store.getters.userInfo.restaurantId;
        const newParams = {restaurantId,...params}
        this.$api.restaurant.resBindSupplierDropDownList(newParams).then(res => {
          if (res.code === 200 && res.success) {
            this.supplierList = res.data.records;
          }
        });
      }
    },
  },
  watch:{
    currentValue(val){
      this.text = val.label;
    }
  }
}
</script>

<style scoped>

</style>